export default "__VITE_ASSET__C3u6cUQr__"